import axios from 'axios'
import { message } from 'antd'
import qs from 'qs'
const isDev = process.env.NODE_ENV === 'development';
const instance = axios.create({
  // 服务器地址需要自己配置和开发
  baseURL: '/API',
  timeout: 1000000,
  withCredentials: true
});

// 添加请求拦截器
instance.interceptors.request.use(
  function (config) {
    // 在发送请求之前做些什么
    const token = sessionStorage.getItem('@token')
    config.headers = {
      authorization: token || '',
    };
    if (config.method === 'post' || config.method === 'POST' || config.methods === 'put' || config.method === 'PUT') {
      if (config.type === 'img') {
        config.headers = {
          ...config.headers,
          'Content-Type': 'multipart/form-data'
        }
      } else {
        config.headers = {
          ...config.headers,
          'X-Requested-With': 'XMLHttpRequest',
          'Content-Type': 'application/x-www-form-urlencoded'
        }
        config.data = qs.stringify(config.data)
      }
    }
    return config;
  },
  function (error) {
    // 对请求错误做些什么
    return Promise.reject(error);
  },
);

// 添加响应拦截器
instance.interceptors.response.use(
  function (response) {
    // 对响应数据做点什么
    // 你的业务数据
    if (response.data.code != 0) {
      message.error(response.data.message || '网络错误');
      throw (response.data.message || '网络错误')
      return
    }
    return response;
  },
  function (error) {
    // 对响应错误做点什么
    const { response } = error;
    if (response) {
      if (response.status === 404) {
        message.error('请求资源未发现');
      } else if (response.status === 403) {
        message.error(response.data.message, () => {
          window.location.href = '/admin/login';
        });
      } else {
        message.error(response.data.message || '网络错误');
      }
    }

    return Promise.reject(error);
  },
);

export default instance;